export { default } from './styleFunctionSx';
export { unstable_createStyleFunctionSx } from './styleFunctionSx';
export { default as extendSxProp } from './extendSxProp';
export { default as unstable_defaultSxConfig } from './defaultSxConfig';


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/styleFunctionSx/index.js
// module id = 76
// module chunks = 22